import * as queryString from 'query-string'

import {
  Block,
  DescBlock,
  Description,
  Divider,
  Frame,
  Information,
  MiddleTitle,
  RowBlock,
  SubTitle,
  Title,
} from '../../components/common'
import React, { useEffect } from 'react'

import FirstSection from '../../container/FirstSection'
import FrontImage from '../../images/strum-audio-whiteboarding-tool.png'
import IMGKeypoint1 from '../../images/keypoint/keypoint1.png'
import IMGKeypoint2 from '../../images/keypoint/keypoint2.png'
import IMGKeypoint3 from '../../images/keypoint/keypoint3.png'
import IMGKeypoint4 from '../../images/keypoint/keypoint5.png'
import IMGWhyStrum1 from '../../images/landing/whystrum1.svg'
import IMGWhyStrum2 from '../../images/landing/whystrum2.svg'
import IMGWhyStrum3 from '../../images/landing/whystrum3.png'
import IconChrome from '../../images/icons/chrome.svg'
import IconEdge from '../../images/icons/edge.svg'
import Layout from '../../components/layout'
import { Link } from 'gatsby'
import MembersImage from '../../images/product/members.png'
import ProductImage from '../../components/images/product'
import RequestAccess from '../../cStrumomponents/RequestAccess'
import SEO from '../../components/seo'
import SVGCamOff from '../../images/icons/camoff.svg'
import SVGLogoText from '../../images/icons/logo-text.svg'
import SVGWhiteboardInfo from '../../images/icons/whiteboard-infographic.svg'
import { gaEvent } from '../../modules/ga'
import graphqlData from '../../graphql.js'
import { useLocation } from '@reach/router'

const SignUp = ({ btn }) => {
  const handleSignup = () => {
    gaEvent('onboarding', 'opensignup', 'signup')

    window.open('https://ncboz5flpy4.typeform.com/to/zgJ98Se4', '_self')
  }
  const handleDemo = () => {
    gaEvent('onboarding', 'opendemo', 'demo')
    // window.open('https://app.strum.us/#/demo')
  }

  return (
    <div className='flex flex-col pb-3 lg:py-6'>
      <a
        onClick={handleSignup}
        className='inline-block h-auto px-4 py-2 text-xl text-white text-gray-200 bg-blue-300 bg-blue-600 rounded-lg cursor-pointer focus:outline-none hover:bg-blue-400 active:bg-blue-300 lg:px-10 lg:py-3 text-bold'
      >
        {btn}
      </a>
      {/* <a
        onClick={handleDemo}
        className='inline-block h-auto px-4 py-2 text-xl text-white text-gray-200 border rounded-lg cursor-pointer focus:outline-none hover:bg-blue-900 lg:px-10 lg:py-3 text-bold'
      >
        Try Demo
      </a> */}
    </div>
  )
}

const StepItem = ({ step, title, image }) => (
  <div className='flex flex-col items-start w-full space-y-3 lg:flex-row justify-items-start lg:h-48'>
    <div className='w-20 h-20 p-3 text-5xl text-center bg-blue-600 rounded-full text-gray-50 text-bold align-center'>
      {step}
    </div>
    <div className='w-0 lg:w-10' />
    <div className='text-left lg:w-96'>
      <Description>{title}</Description>
    </div>
    <div className='lg:w-10' />
    <div className='flex flex-col items-center w-52'>
      <img src={image} />
    </div>
  </div>
)

const SlackButton = () => (
  <a href='https://slack.com/oauth/v2/authorize?client_id=641375666771.1471161437335&scope=channels:history,channels:read,chat:write,commands,files:read,files:write,groups:read,groups:write,im:history,im:write,mpim:write,users.profile:read,users:read,channels:manage&user_scope=channels:write,groups:write,mpim:write,im:write'>
    <img
      alt='Add to Slack'
      height='40'
      width='139'
      src='https://platform.slack-edge.com/img/add_to_slack.png'
      srcSet='https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x'
    />
  </a>
)

const Home = () => {
  const location = useLocation()
  if (location.search === '?ref=producthunt') {
    gaEvent('onboarding', 'landing', 'producthunt')
  }
  // console.log(graphqlData())
  const homeApiData = graphqlData()

  const {
    allMarkdownRemark: { nodes },
  } = homeApiData
  const hero = nodes.filter(
    (data) => data.frontmatter.templateKey === 'hero-section',
  )?.[0]
  const videoSec = nodes.filter(
    (data) => data.frontmatter.templateKey === 'video-section',
  )?.[0]
  const converSec = nodes.filter(
    (data) => data.frontmatter.templateKey === 'conversation-secttion',
  )?.[0]
  const workSec = nodes.filter(
    (data) => data.frontmatter.templateKey === 'work-secttion',
  )?.[0]
  const strumSec = nodes.filter(
    (data) => data.frontmatter.templateKey === 'strum-section',
  )?.[0]
  const feturSec = nodes.filter(
    (data) => data.frontmatter.templateKey === 'features-section',
  )?.[0]

  return (
    <Layout>
      <SEO
        title={`Strum - ${hero.frontmatter.main_title}`}
        description='Visualized remote collaboration tool'
      />
      {/* <FirstSection /> */}

      <Frame>
        <a
          href='https://www.producthunt.com/posts/strum?utm_source=badge-review&utm_medium=badge&utm_souce=badge-strum#discussion-body'
          target='_blank'
          rel='noreferrer'
        >
          <img
            src={hero.frontmatter.strum_image}
            alt={`Strum - ${hero.frontmatter.main_title} | Product Hunt`}
            style={{ width: '250px', height: '54px' }}
            width='250'
            height='54'
          />
        </a>
        <Title>
          {hero.frontmatter.main_title.split(' ').slice(0, 2).join(' ')}
          <br />
          {hero.frontmatter.main_title
            .split(' ')
            .slice(2, hero.frontmatter.main_title.length)
            .join(' ')}
        </Title>
        <SubTitle>
          {hero.frontmatter.sub_title.split(' ').slice(0, 4).join(' ')}
          <br />
          {hero.frontmatter.sub_title
            .split(' ')
            .slice(4, hero.frontmatter.sub_title.length)
            .join(' ')}
        </SubTitle>
        {/* <SignUp btn={hero.frontmatter.sign_up_button} /> */}
        <SignUp btn={'Request Access'} />
        {/* <div className='flex flex-row justify-center space-x-2 center align-center'>
          <Information>Use</Information>
          <img src={IconChrome} className='h-4 sm:h-3' />
          <Information>Google Chrome or</Information>
          <img src={IconEdge} className='h-4 sm:h-3' />
          <Information>Microsoft Edge to access Strum</Information>
        </div> */}

        {/* <div className='flex flex-row space-x-2 text-sm text-gray-300 lg:text-sm'>
          <div>Use</div><img src={IconChrome}/><div>Google Chrome or</div><img src={IconEdge}/><div>Microsoft Edge to access Strum</div>
        </div> */}

        {/* <div className='flex flex-col items-center space-y-0'>
          <Information>Add Strum app to Slack for beta-testing. <a href='#slack' className='text-blue-500'>See details</a></Information>
          <SlackButton/>
        </div> */}

        <div className='max-w-screen-xl'>
          <img
            src={hero.frontmatter.whiteboarding_image}
            className='py-2 lg:py-6'
          />
        </div>
        <div className='flex flex-col items-center space-y-0'>
          <Information>{hero.frontmatter.bottom_title}<a href='https://strum.us/slack' className='text-blue-500'>See details</a></Information>
          <SlackButton/>
        </div>
      </Frame>
      {/* <div className='center'>
        <ProductImage/>
      </div> */}

      {/* Problem */}
      <div className='w-full bg-blue-900 bg-gradient-to-r from-green-400 to-blue-500 bg-opacity-30'>
        <Frame>
          <div className='flex flex-col items-center w-full lg:w-6/12'>
            <img
              src={videoSec.frontmatter.camoff_image}
              className='w-8 py-2 lg:w-16 lg:py-3'
            />
            <MiddleTitle>{videoSec.frontmatter.Man_heading}</MiddleTitle>
            <Description>
              {videoSec.frontmatter.sub_heading
                .split(' ')
                .slice(0, 6)
                .join(' ')}
              <br />
              {videoSec.frontmatter.sub_heading
                .split(' ')
                .slice(6, videoSec.frontmatter.sub_heading.length)
                .join(' ')}
            </Description>
          </div>
          <br />
        </Frame>
      </div>

      <div className='lg:py-12' />

      <Frame>
        <img
          src={converSec.frontmatter.strumlogo_image}
          className='w-48 lg:w-80 lg:py-6'
        />
        <Title>
          {converSec.frontmatter.heading_one.split(' ').slice(0, 4).join(' ')}
          <br />
          {converSec.frontmatter.heading_one
            .split(' ')
            .slice(4, converSec.frontmatter.heading_one.length)
            .join(' ')}
        </Title>
        <img
          src={converSec.frontmatter.infographic_image}
          className='w-10/12 max-w-screen-lg lg:w-10/12 lg:py-8'
        />
        <img
          src={converSec.frontmatter.members_image}
          className='w-9/12 lg:w-6/12'
        />
      </Frame>

      <div className='flex flex-col items-center'>
        <Divider />
      </div>

      {/* How it works */}
      <Frame>
        <Block />
        <Title>{workSec.frontmatter.work_heading}</Title>
        <video
          src={workSec.frontmatter.work_video}
          controls
          className='max-w-full lg:max-w-screen-lg'
        />
      </Frame>

      {/* Why Strum */}
      <Frame>
        <Title>{strumSec.frontmatter.strum_heading}</Title>
        <br />
        {/* <div className='grid grid-cols-1 gap-x-10 gap-y-10 lg:grid-cols-2 lg:gap-x-20 lg:gap-y-32'> */}
        <div className='space-y-4 lg:space-y-16'>
          {strumSec.frontmatter.intarg.Strum.map((Itums, index) => {
            return index % 2 == 0 ? (
              <RowBlock>
                <img
                  src={Itums.Strum_image}
                  className='w-6/12 lg:w-4/12 lg:w-80'
                ></img>
                <DescBlock>
                  <MiddleTitle>{Itums.strum_main_text} </MiddleTitle>
                  <Description>{Itums.strum_sub_text}</Description>
                </DescBlock>
              </RowBlock>
            ) : (
              <RowBlock>
                <DescBlock>
                  <MiddleTitle>{Itums.strum_main_text}</MiddleTitle>
                  <Description>{Itums.strum_sub_text}</Description>
                </DescBlock>
                <img src={Itums.Strum_image} className='w-6/12 lg:w-80'></img>
              </RowBlock>
            )
          })}

          {/* <RowBlock>
            <DescBlock>
              <MiddleTitle>
                Different file extensions,
                <br />
                Different applications
              </MiddleTitle>
              <Description>
                So many applications are required
                <br />
                just to review works in progress
              </Description>
            </DescBlock>
            <img src={IMGWhyStrum2} className="w-6/12 lg:w-80"></img>
          </RowBlock>

          <div className="py-8 gl:py-0 " />
          <RowBlock>
            <img src={IMGWhyStrum3} className="w-6/12 lg:w-80"></img>
            <DescBlock>
              <MiddleTitle>Discuss all outcomes in one place!</MiddleTitle>
              <Description>
                Every work ourcome can be simply displayed and reviewed in a
                single platform
              </Description>
            </DescBlock>
          </RowBlock> */}
        </div>
      </Frame>

      <Frame>
        <Title>{feturSec.frontmatter.featu_heading}</Title>
        <div className='space-y-4 lg:space-y-16'>
          {feturSec.frontmatter.intarg.features.map((Item) => {
            return (
              <RowBlock>
                <DescBlock>
                  <MiddleTitle>{Item.featur_main_text}</MiddleTitle>
                  <Description>{Item.featur_sub_text}</Description>
                </DescBlock>
                <img src={Item.featur_image} className='w-6/12 lg:w-80' />
              </RowBlock>
            )
          })}
        </div>
      </Frame>

      {/* <div className='flex flex-col items-center'>
        <Divider/>
      </div> */}

      {/* <Frame>
        <div className='flex flex-col items-center lg:flex-row space-10'>
          <DescBlock>
            <MiddleTitle>It’s time to explore!</MiddleTitle>
            <Description>Stop Downloading, Start Sharing</Description>
          </DescBlock>
          <SignUp/>
        </div>
      </Frame> */}
    </Layout>
  )
}

export default Home
